import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { AssessmentDataService } from "../../../../providers/asmt-data-service/asmt-data-service";
import { IntercardDataService } from "../intercard-data/intercard-data.service";

/**
 * Generated class for the DeclineCardComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */

@Component({
  selector: "decline-card",
  templateUrl: "decline-card.html",
})
export class DeclineCardComponent implements OnInit, AfterViewInit {
  @Input() assessmentId: string;
  @Input() sectionId: string;
  @Input() sectionName: string;
  @Input() config;
  @Output() onDeclineStateChange: EventEmitter<any> = new EventEmitter();
  @Output() onNoChangeStateChange: EventEmitter<any> = new EventEmitter();
  @Output() onDataUpdate: EventEmitter<any> = new EventEmitter();
  @Output() onCardInitialized: EventEmitter<any> = new EventEmitter();

  // Internal data model
  group: FormGroup;
  componentId: string;
  reasonConfig: object;
  name: string;
  access: string;
  labelColor: string;
  placeholder: string = "";
  maxLength: number;
  minLength: number;
  required: boolean;
  declined: boolean = false;
  noChanges: boolean = false;
  noChangesEnabled: boolean;
  cardId: string;

  initialized: boolean = false;

  constructor(
    public formBuilder: FormBuilder,
    public dataService: AssessmentDataService,
    public intercard: IntercardDataService
  ) {
    // console.log('Hello DeclineCardComponent Component');
  }

  ngOnInit(): void {
    // console.log( "Group: ", this.group );
    // console.log( "Decline card config: ", this.config );

    this.name = this.config.cardName;
    this.componentId = this.config.componentId;
    this.access = this.config.access;
    this.labelColor = this.config.labelColor;
    this.noChangesEnabled = this.config.noChanges;

    var controlConfig = {
      declined: [""],
      noChanges: [""],
    };

    this.group = this.formBuilder.group(controlConfig);

    this.cardId = this.config.id;

    this.group.controls["declined"].valueChanges.subscribe((data) => {
      this.onDeclineStateChange.emit(this.declined);
      this.onDataUpdate.emit({ cardId: this.cardId, value: data });
      if (data && this.initialized) {
        this.intercard.emitData("notes", { declined: true });
      }
    });

    this.group.controls["noChanges"].valueChanges.subscribe((data) => {
      this.onNoChangeStateChange.emit(this.noChanges);
      this.onDataUpdate.emit({ cardId: this.cardId, value: data });
      //if( data && this.initialized ) {
      //   this.intercard.emitData( "notes", {"noChanges": true} );
      //}
    });

    this.group.valueChanges.subscribe((data) => {
      // console.log( "Decline Card emitting udpated value:", data );
      this.onDataUpdate.emit({ cardId: this.cardId, value: data });
    });

    // console.log( "Attempting to register." );
    this.intercard.register("declines").subscribe((data) => {
      if (data["acceptedDecline"]) {
        // console.log("accept");
        this.group.controls["declined"].setValue(true, { emitEvent: false });
        this.group.controls["noChanges"].setValue(false, { emitEvent: false });
      } else if (data["acceptedNoChanges"]) {
        this.group.controls["noChanges"].setValue(true, { emitEvent: false });
      } else if (data["rejectedDeclined"]) {
        // console.log("rejected decline");
        this.group.controls["declined"].setValue(false);
      } else if (data["rejectedNoChanges"]) {
        // console.log("rejected no change");
        this.group.controls["noChanges"].setValue(false);
      }
    });
  }

  ngAfterViewInit() {}

  @Input() set data(incomingData: any) {
    // console.log( "Dyn form Data: ", this.data );
    // console.log( "Dyn form Incoming data: ", incomingData );
    if (incomingData && incomingData.data && incomingData.data[0]) {
      // console.log(incomingData);
      if (this.group) {
        // console.log( incomingData.data[0] );
        for (let key of Object.keys(incomingData.data[0])) {
          if (this.group.controls[key]) {
            // console.log(incomingData);
            // console.log(key);
            this.group.controls[key].setValue(incomingData.data[0][key]);
          }
        }
      }
    }
    !this.initialized;
    if (incomingData !== undefined) {
      //&& !this.initialized
      // console.log( "Flagging decline card as initialized.", this.name );
      this.initialized = true;
      this.onCardInitialized.emit(this.cardId);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/cards/decline-card/decline-card.ts